"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSettingValueFromRow = mapSettingValueFromRow;
const mapSettingValue_1 = require("./mapSettingValue");
function mapSettingValueFromRow(row) {
    return (0, mapSettingValue_1.mapSettingValue)(row.columns.value, row.columns.type);
}
